module.exports = __webpack_public_path__ + "static/img_pledge_interview_01-8d71a63891081501b8574ff6f1bb45ec.png";